import React, { useState } from "react";
import { FiPlayCircle, FiX } from "react-icons/fi";

// Vídeo de explicación de la app para clientes. Se puede ocultar y volver a ver.
const CLAVE = "titan-video-explicacion-oculto";

function leerOculto() {
  try {
    return localStorage.getItem(CLAVE) === "1";
  } catch {
    return false;
  }
}

export default function VideoBienvenida() {
  const [oculto, setOculto] = useState(leerOculto);

  const cambiar = (valor) => {
    setOculto(valor);
    try {
      if (valor) localStorage.setItem(CLAVE, "1");
      else localStorage.removeItem(CLAVE);
    } catch {}
  };

  if (oculto) {
    return (
      <button
        type="button"
        className="app-btn app-btn-quiet app-btn-sm"
        style={{ marginBottom: 16 }}
        onClick={() => cambiar(false)}
      >
        <FiPlayCircle aria-hidden="true" /> Ver la explicación de tu app
      </button>
    );
  }

  return (
    <section className="app-panel" style={{ marginBottom: 20, padding: 16, position: "relative" }}>
      <button
        type="button"
        onClick={() => cambiar(true)}
        aria-label="Ocultar vídeo"
        title="Ocultar"
        style={{ position: "absolute", top: 12, right: 12, background: "none", border: 0, cursor: "pointer", color: "inherit", fontSize: 20 }}
      >
        <FiX />
      </button>
      <h2 style={{ margin: "0 32px 4px 0", fontSize: 20 }}>Explicación de tu app</h2>
      <p style={{ margin: "0 0 12px", opacity: 0.75 }}>
        Cómo funciona Titan Training en 2 minutos, y cómo tenerla a un toque en tu móvil.
      </p>
      <video
        src="/explicacion-titan-training.mp4"
        poster="/explicacion-titan-training.jpg"
        controls
        playsInline
        preload="none"
        style={{ width: "100%", maxWidth: 360, display: "block", margin: "0 auto", borderRadius: 16, background: "#0E1311" }}
      />
    </section>
  );
}
